export default function PrivacyPage() {
  return (
    <div data-testid="privacy-page" className="section-padding bg-white">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-slate-900 mb-8">Privacy Policy</h1>
          
          <div className="prose prose-slate max-w-none">
            <p className="text-lg text-slate-600 mb-8">
              Last updated: December 2024
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">1. Introduction</h2>
              <p className="text-slate-600 mb-4">
                Certisfy ("we", "our", or "us") is committed to protecting your privacy. This Privacy 
                Policy explains how we collect, use, disclose, and safeguard your information when you 
                use our phytosanitary certification platform and related services.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">2. Information We Collect</h2>
              <p className="text-slate-600 mb-4">
                We collect information you provide directly to us, including:
              </p>
              <ul className="list-disc pl-6 text-slate-600 space-y-2">
                <li>Contact information (name, email, phone number, organization)</li>
                <li>Application data for phytosanitary certificates</li>
                <li>Documents uploaded for certification purposes</li>
                <li>Communication records and support inquiries</li>
                <li>Account credentials and profile information</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">3. How We Use Your Information</h2>
              <p className="text-slate-600 mb-4">
                We use the information we collect to:
              </p>
              <ul className="list-disc pl-6 text-slate-600 space-y-2">
                <li>Process and manage phytosanitary certificate applications</li>
                <li>Facilitate communication between exporters, inspectors, and regulators</li>
                <li>Provide customer support and respond to inquiries</li>
                <li>Send notifications about application status and system updates</li>
                <li>Maintain audit trails for compliance purposes</li>
                <li>Improve our services and develop new features</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">4. Data Security</h2>
              <p className="text-slate-600 mb-4">
                We implement appropriate technical and organizational security measures to protect 
                your personal information, including encryption, access controls, and regular 
                security assessments. However, no method of transmission over the Internet or 
                electronic storage is 100% secure.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">5. Data Retention</h2>
              <p className="text-slate-600 mb-4">
                We retain your information for as long as necessary to fulfill the purposes outlined 
                in this Privacy Policy, unless a longer retention period is required or permitted by 
                law. Certificate records are retained in accordance with regulatory requirements.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">6. Your Rights</h2>
              <p className="text-slate-600 mb-4">
                Depending on your location, you may have certain rights regarding your personal 
                information, including the right to access, correct, or delete your data. To exercise 
                these rights, please contact us using the information provided below.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">7. Contact Us</h2>
              <p className="text-slate-600">
                If you have any questions about this Privacy Policy, please contact us at:<br />
                Email: privacy@certisfy.com<br />
                Address: Pretoria, South Africa
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
